module.exports = __webpack_public_path__ + "img/charmed.51d02198.svg";